import React from 'react';
import { StarIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const testimonials = [{
  name: 'María, 43 años',
  quote: 'Llevo una semana y ya duermo mejor. No podía creer que algo tan simple se notara tan rápido.',
  avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/9edcfaac-7b4c-4f1c-8502-638fb51f60df.jpg'
}, {
  name: 'Laura, 38 años',
  quote: 'Llevaba 2 años sintiéndome inflamada y sin energía. En los primeros días ya me siento más liviana.',
  avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/53a8d15a-b24e-4a36-b7e3-467bcddfe14a.jpg'
}, {
  name: 'Carolina, 47 años',
  quote: 'El método es suave, sin sacrificios extremos. Por primera vez siento que puedo sostenerlo.',
  avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/bdbc789f-2bbd-41ac-8970-30fdfbd0233f.jpg'
}];
export function TestimonialsSection() {
  return <section className="w-full bg-white py-20 sm:py-28" data-id="element-221" data-mp="32egcx6x9hslp">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-222" data-mp="2v09nmna09044">
        <Reveal className="mx-auto max-w-2xl text-center" data-id="element-223" data-mp="2q2hop9ay0dqf">
          <span className="inline-flex items-center gap-2 rounded-full bg-rosa/15 px-4 py-1.5 text-xs font-medium uppercase tracking-[0.18em] text-rosa-dark" data-id="element-224" data-mp="2q27tn7b1jgdv">
            Primeras semanas
          </span>
          <h2 className="mt-5 font-serif text-3xl font-semibold text-tinta sm:text-4xl lg:text-5xl" data-id="element-225" data-mp="2zt2qt6pts0e3">
            Lo que dicen las mujeres que ya empezaron
          </h2>
          <p className="mt-4 text-lg text-tinta/70" data-id="element-226" data-mp="274otkt6k983l">
            La app acaba de lanzarse. Estas son las primeras impresiones de
            mujeres que están en sus primeros días del método.
          </p>
        </Reveal>

        <ul className="mt-14 grid gap-6 lg:grid-cols-3" data-id="element-227" data-mp="2h0i2m2l2mjgm">
          {testimonials.map((t, i) => <Reveal as="li" key={t.name} delay={i * 0.1} className="h-full" data-id="element-228" data-mp="18u8eexfz51i" data-mpi={i}>
              <figure className="flex h-full flex-col rounded-3xl border border-nude/70 bg-crema/50 p-7 shadow-sm" data-id="element-229" data-mp="3sg6pyv28lkhy">
                <div className="flex items-center gap-4" data-id="element-230" data-mp="3e936luzolbh">
                  <img src={t.avatar} alt="" className="h-14 w-14 shrink-0 rounded-full object-cover" loading="lazy" data-id="element-231" data-mp="8dc2rqs79zc2" />
                  <figcaption className="font-serif text-lg font-semibold text-tinta" data-id="element-232" data-mp="ib026u0r3v0k">
                    {t.name}
                  </figcaption>
                </div>

                <div className="mt-5 flex items-center gap-1" role="img" aria-label="5 de 5 estrellas" data-id="element-233" data-mp="3lsi6wsl88lwr">
                  {Array.from({
                length: 5
              }).map((_, star) => <StarIcon key={star} className="h-4 w-4 fill-dorado text-dorado" strokeWidth={1.5} aria-hidden="true" data-id="element-234" data-mp="3vk4g6je08awv" data-mpi={star} />)}
                </div>

                <blockquote className="mt-4 text-base leading-relaxed text-tinta/75" data-id="element-235" data-mp="1k7fleutpbh71">
                  “{t.quote}”
                </blockquote>
              </figure>
            </Reveal>)}
        </ul>

        <Reveal delay={0.3} data-id="element-236" data-mp="1b5ek9mvckb03">
          <p className="mt-10 text-center text-sm text-tinta/65" data-id="element-237" data-mp="1b4mu4rkir5h7">
            Primeras impresiones de las mujeres que ya comenzaron
          </p>
        </Reveal>
      </div>
    </section>;
}